/** Reports one page may send (review 0019 U6): a render loop must not flood the server. */
export const MAX_REPORTS = 5;

export interface ReportLedger {
  readonly sent: number;
  readonly seen: ReadonlySet<string>;
}

/** Whether a report with this signature goes out, and the ledger after it. Pure. */
export function nextReport(
  ledger: ReportLedger,
  signature: string,
): { send: boolean; ledger: ReportLedger } {
  if (ledger.sent >= MAX_REPORTS || ledger.seen.has(signature)) return { send: false, ledger };
  return {
    send: true,
    ledger: { sent: ledger.sent + 1, seen: new Set([...ledger.seen, signature]) },
  };
}

/** The first line of a message and a stack, clipped to what the server takes. Pure. */
export function clip(text: string | undefined, max: number): string | undefined {
  if (text === undefined) return undefined;
  return text.length > max ? text.slice(0, max) : text;
}
